import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { disputeHistoryActions } from "../../../../../store/external/invoice/dispute/dispute-history.reducer";
import { TablePagination } from "../../../../common/details-table/table-pagination.component";

class DisputeDetailsHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableSearchBox: false
        }
    }

    componentDidMount() {
        this.props.getDisputeHistoryLogs(this.props.disputeDetailsId);
    }

    componentWillUnmount() {
        this.props.resetDisputeHistory();
    }

    getTableData(pageIndex) {
        this.props.getDisputeHistoryLogs(this.props.disputeDetailsId, pageIndex);
    }

    resizePage = (pageSize) => {
        const { resizeDisputeHistoryLogs, getDisputeHistoryLogs, disputeDetailsId } = this.props;
        resizeDisputeHistoryLogs(pageSize)
        getDisputeHistoryLogs(disputeDetailsId);
    }

    disputePaginationAction = (pageIndex) => {
        const { getDisputeHistoryLogs, disputeDetailsId } = this.props;
        getDisputeHistoryLogs(disputeDetailsId, pageIndex);
    }

    onColumnSearch = () => {
        const { getDisputeHistoryLogs, disputeDetailsId } = this.props;
        getDisputeHistoryLogs(disputeDetailsId, 0);
    }


    render() {

        const { setDisputeHistoryColSearchStr } = this.props;
        const { IsLoadingTable } = this.props.invoiceDisputeHistory;
        const { Headers, Data, Pagination } = this.props.invoiceDisputeHistory.HistoryTable;
     
        return (

                <TablePagination
                key="table-pagination-key"
                columns={Headers}
                pageList={Data}
                pages={Pagination}
                paginationAction={this.disputePaginationAction}
                onColumnSearch={() => { this.onColumnSearch() }}
                onColumnSearchChange={setDisputeHistoryColSearchStr}
                isColSearchShow={this.props.isColSearchShow}
                resizePage={this.resizePage}
                totalPage={Pagination.TotalEntries}
                isNotSortable={true}
                isLoading={IsLoadingTable}
                hideStatusIcon={true}
                    />

        );
    }
}

export default connect(
    state => {
        const { invoiceDisputeHistory } = state;

        return {
            invoiceDisputeHistory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, disputeHistoryActions),
        dispatch
    )
)(DisputeDetailsHistory);